// Champ "Temps de repos par défaut" utilisé dans les modales create/edit
// d'exercice. Le repos est stocké en secondes côté API ; on affiche 2 inputs
// mm:ss + une rangée de presets calqués sur les valeurs habituelles utilisées
// pour l'app (2min30 iso, 3min30 gros composés). 0 = pas défini (l'app utilise
// alors son fallback à 90s).
import React from "react";

const PRESETS = [
	{ label: "1min30", value: 90 },
	{ label: "2min", value: 120 },
	{ label: "2min30", value: 150 },
	{ label: "3min", value: 180 },
	{ label: "3min30", value: 210 },
];

export default function RestTimeField({ value, onChange }) {
	const total = parseInt(value, 10) || 0;
	const min = Math.floor(total / 60);
	const sec = total % 60;

	const setMin = (v) => {
		const m = Math.max(0, Math.min(59, parseInt(v, 10) || 0));
		onChange(m * 60 + sec);
	};
	const setSec = (v) => {
		let s = parseInt(v, 10);
		if (isNaN(s)) s = 0;
		s = Math.max(0, Math.min(59, s));
		onChange(min * 60 + s);
	};

	return (
		<div className="exercise-edit-field">
			<label className="exercise-edit-label">
				Temps de repos par défaut
				<span className="rest-time-hint"> — utilisé par le timer de l'app entre les séries</span>
			</label>
			<div className="rest-time-row">
				<div className="rest-time-inputs">
					<div className="rest-time-input-wrap">
						<input
							type="number"
							min="0"
							max="59"
							value={min}
							onChange={(e) => setMin(e.target.value)}
							className="rest-time-input"
							aria-label="Minutes"
						/>
						<span className="rest-time-unit">min</span>
					</div>
					<div className="rest-time-input-wrap">
						<input
							type="number"
							min="0"
							max="59"
							value={sec}
							onChange={(e) => setSec(e.target.value)}
							className="rest-time-input"
							aria-label="Secondes"
						/>
						<span className="rest-time-unit">sec</span>
					</div>
				</div>
				<div className="rest-time-presets">
					{PRESETS.map((p) => (
						<button
							key={p.value}
							type="button"
							className={`rest-time-preset ${total === p.value ? "active" : ""}`}
							onClick={() => onChange(p.value)}
						>
							{p.label}
						</button>
					))}
				</div>
			</div>
			{total === 0 && (
				<div className="rest-time-fallback-note">Non défini — l'app utilisera 1min30 par défaut.</div>
			)}
		</div>
	);
}
